import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
import { Black, Dark, Gray12, Shadow, WerfenColor, WerfenColorLight, White } from '../../Constants/ColorChart'
import { setTitleBar } from "../../../actions/ui"
import { connect } from "react-redux"

import TrainingGuide from '../../Assets/WerfenDocs_User_Site.pptx';
import EmployeesManual from '../../Assets/Werfen_Docs_Employees_Manual_Rev01.pdf';
import PartnersManual from '../../Assets/Werfen_Docs_Partners_User_Manual_Rev01.pdf';

/*
 *  @Description:   Stateless component that renders a Section with the FAQs.
 */

const Card = styled.div`
    width: 100%;
    margin-bottom:3%;
    color: ${ Black };
    padding: 4%;
    box-shadow: 0px 0px 20px ${ Shadow };
    @media (min-width: 992px) {
        padding: 2%;
    }
`;

const Wrapper = styled.div`
    margin-top: 70px;
    h1 {
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .card-faq{
        &-title{
            padding-bottom: 20px;
        }
        &-table{
            &-row{
                border-top: 1px solid ${ Gray12 };
                border-bottom: 1px solid ${ Gray12 };
                &__0 {
                    border-top: 0 solid transparent;
                    border-bottom: 0 solid transparent;
                    div {
                        white-space: normal;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: left;
                        color: ${ Dark };
                        text-transform: uppercase;
                        font-weight: 100;
                        font-size: 14px;
                        letter-spacing: 2px;
                        p {
                            margin-left: 0.1vw;
                        }
                    }
                }
                div {
                    font-size: 12px;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    @media screen and (min-width: 768px){
                        font-size: 15px;
                    }
                    @media screen and (min-width: 992px){
                        font-size: 17px;
                    }
                    @media screen and (min-width: 1200px){
                        font-size: 19px;
                    }
                }
            }
        }
    }
    .btn-default-werfen {
        background: ${ WerfenColorLight };
        border: 0 none transparent;
        color: ${ White };
        font-size: 15px;
        font-weight: 500px;
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        transition: all 300ms;
        display: block;
        width: 200px;
        border-radius: 0px;
        margin-left: auto;
        margin-right: auto;
        &:hover, &:focus, &:active{
            background: ${ WerfenColor };
            color: ${ White };
            border: 0 none transparent;
        }
    }
`;

const FAQs = [
    {
        question: "What is " + process.env.REACT_APP_SITE_APP_NAME + "?",
        answer: [ "" + process.env.REACT_APP_SITE_APP_NAME + " is an Online application that will keep organized all the documents that you need in order to realize your work.",
            "Werfen Docs was born from the ideal of having a clear and simple interface so that finding SAP and non SAP documents is intuitive and easy to use.",
            "This tool is not a substitute of SAP document access, it aims to provide also an easier experience to it and, as such, it will allow an alternative way to access SAP and non SAP documents." ]
    },
    {
        question: "What will I find in " + process.env.REACT_APP_SITE_APP_NAME + "?",
        answer: [ "Content editors have now a way to present documents from SAP or added Locally in an easier manner.",
            "The search tool provides the means to locate the documents you need, easily.",
            "You will be able to get to the resources you need or find them with other ones associated within Playlists.",
            "Search all of the Resource library you have access to from a familiar interface that can narrow your search and help you find what you are looking for faster." ]
    },
    // {
    //     question: "How to use it?",
    //     answer: [ "We've made sure " + process.env.REACT_APP_SITE_APP_NAME + " works the easiest way possible. Just type into the home's or top search bar and click into the results." ],
    //     table: [ [ "Operator", "Example", "Result" ],
    //         [ "Nothing", "barcode bpm reference", "This will show all the results that contain the word 'barcode' OR  the word 'bpm' OR the word 'reference' or the three of them." ],
    //         [ "&&", "barcode && bpm", "This will show all the results that contain the word 'barcode' AND the word 'bpm'." ],
    //         [ "AND", "barcode AND bpm", "This will show all the results that contain the word 'barcode' AND the word 'bpm'." ],
    //         [ "+", "+barcode +bpm +reference", "This will show all the results that contain the word 'barcode' AND the word 'bpm' AND the word 'reference'." ],
    //         [ "-", "+barcode +bpm -reference", "This will show all the results that contain the word 'barcode' AND the word 'bpm' BUT WITHOUT the word 'reference'." ],
    //         [ "\" \"", "\"WITH BARCODE 2015-10\"", "This will show all the results that contain exactly the text \"WITH BARCODE 2015-10\"." ],
    //         [ "Multiple Operators", "+\"WITH BARCODE 2015-10\" +\"REF 503-10-US\" -\"ACL TOP\"​", "This will show all the experiences that contains exactly the text \"WITH BARCODE 2015-10\" and contains exactly the ​text \"REF 503-10-US\" too and not have exactly the text \"ACL TOP\"​." ],
    //         [ "\\", "\\*\\*\\*IS​", "Because + - && || ! ( ) { } [ ] ^ \" ~ * ? : / are operators, when we need to​ search something that contains this characters is necessary use the \"\\\"​ character to escape. This example \\*\\*\\*IS will show all the experiences​ that contains the text ***IS​." ],
    //     ]
    // },
]

const FAQ = ( props ) => {
    useEffect( () => {
        props.changeTitle( "FAQ" );
        window.scrollTo( 0, 0 );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <Container>
            <Row>
                <Col>
                    <Wrapper>
                        <h1>Frequently Asked Questions</h1>
                        { FAQs.map( ( faq, index ) => {
                            return <Card key={ `FAQ${ index }` } className={ "card card-faq" }>
                                <h2 className={ "card-faq-title" }>{ faq.question }</h2>
                                <div className={ "card-faq-body" }>{ faq.answer.map( ( paragraph, pIndex ) => {
                                    return (
                                        <p className={ `card-faq-paragraph card-faq-paragraph__${ pIndex }` }
                                           key={ `FAQ${ pIndex }` }>
                                            { paragraph }
                                        </p>
                                    )
                                } ) }
                                    <div className={ "card-faq-table container-fluid" }>
                                        { faq.table !== undefined ?
                                            faq.table.map( ( tableRow, trIndex ) => {
                                                return (
                                                    <div key={ trIndex }
                                                         className={ "row card-faq-table-row card-faq-table-row__" + trIndex }>
                                                        { tableRow.map( ( tableCell, tdIndex ) => {
                                                            return (
                                                                <div key={ tdIndex }
                                                                     className={ "col-xs-" + ((tdIndex + 1) * 2) + " card-faq-table-cell card-faq-table-cell__" + tdIndex }>
                                                                    <p>
                                                                        { tableCell }
                                                                    </p>
                                                                </div>
                                                            )
                                                        } ) }
                                                    </div>
                                                )
                                            } )
                                            : "" }
                                    </div>
                                </div>
                            </Card>
                        } ) }
                        <Card>
                            <h2 className={ "card-faq-title" }>Do you need more information?</h2>
                            { process.env.REACT_APP_SITE_ID !== "48" && <div className={ "card-faq-body" }>
                                <p className={ "card-faq-paragraph card-faq-paragraph__pptx" }>
                                    Here you'll find the training guides.
                                </p>
                                <div className={ "text-center" }>
                                    <a className={ "btn btn-default btn-default-werfen" }
                                       href={ TrainingGuide }> Download </a>
                                </div>
                            </div> }
                            { process.env.REACT_APP_SITE_ID === "48" && <div className={ "card-faq-body" }>
                                <p className={ "card-faq-paragraph card-faq-paragraph__pptx" }>
                                    Here you'll find the site's manual.
                                </p>
                                <div className={ "text-center" }>
                                    { props.session.isEmployee && <a
                                        className={ "btn btn-default btn-default-werfen" }
                                        href={ EmployeesManual }>
                                        Employees Manual
                                    </a> }
                                    { !props.session.isEmployee && <a
                                        className={ "btn btn-default btn-default-werfen" }
                                        href={ PartnersManual }>
                                        Partners Manual
                                    </a> }
                                </div>
                            </div> }
                        </Card>
                    </Wrapper>
                </Col>
            </Row>
        </Container>
    )
}

const mapStateToProps = ( state ) => ({
    session: state.session
});

export default connect( mapStateToProps, { setTitleBar } )( FAQ );
